import { useState, type FC } from 'react'
import { cn } from '@/lib/utils'
import { ExchangeRatesTab } from '@/components/rates/ExchangeRatesTab'
import { InterestRatesTab } from '@/components/rates/InterestRatesTab'
import { UrgentLiquidityTab } from '@/components/rates/UrgentLiquidityTab'
import { AutoStackTab } from '@/components/rates/AutoStackTab'
import { TransactionChargesTab } from '@/components/rates/TransactionChargesTab'
import { CryptoBuffersTab } from '@/components/rates/CryptoBuffersTab'

type TabType =
    | 'exchange'
    | 'interest'
    | 'urgentLiquidity'
    | 'autoStack'
    | 'transactionCharges'
    | 'cryptoBuffers'

const tabs = [
    { id: 'exchange' as const, label: 'Exchange Rates' },
    { id: 'interest' as const, label: 'Interest rates' },
    { id: 'urgentLiquidity' as const, label: 'Urgent Liquidity' },
    { id: 'autoStack' as const, label: 'Auto Stack rates' },
    { id: 'transactionCharges' as const, label: 'Transaction charges' },
    { id: 'cryptoBuffers' as const, label: 'Crypto buffers' },
]

const TransactionSettings: FC = () => {
    const [activeTab, setActiveTab] = useState<TabType>('exchange')

    return (
        <div className="space-y-6">
            {/* Tabs Navigation */}
            <div className="overflow-x-auto">
                <div className="flex min-w-max gap-6 border-b border-border pb-0">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={cn(
                                'relative whitespace-nowrap pb-3 text-sm font-medium transition-colors',
                                activeTab === tab.id
                                    ? 'text-foreground'
                                    : 'text-muted-foreground hover:text-foreground'
                            )}
                        >
                            {tab.label}
                            {activeTab === tab.id && (
                                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#17A2B8]" />
                            )}
                        </button>
                    ))}
                </div>
            </div>

            {/* Tab Content */}
            <div className="pb-8">
                {activeTab === 'exchange' && <ExchangeRatesTab />}
                {activeTab === 'interest' && <InterestRatesTab />}
                {activeTab === 'urgentLiquidity' && <UrgentLiquidityTab />}
                {activeTab === 'autoStack' && <AutoStackTab />}
                {activeTab === 'transactionCharges' && (
                    <TransactionChargesTab />
                )}
                {activeTab === 'cryptoBuffers' && <CryptoBuffersTab />}
            </div>
        </div>
    )
}

export default TransactionSettings
